// 用户信息管理模块
const state = {
  token: localStorage.getItem('ksH5token') || '',
  userInfo: JSON.parse(localStorage.getItem('userInfo')) || null,
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
    localStorage.setItem('ksH5token', token)
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  },
  CLEAR_USER_INFO: state => {
    state.token = ''
    state.userInfo = null
    localStorage.removeItem('ksH5token')
    localStorage.removeItem('userInfo')
  },
}

const actions = {
  // 设置用户信息
  setUserInfo({ commit }, { token, userInfo }) {
    commit('SET_TOKEN', token)
    commit('SET_USER_INFO', userInfo)
  },
  // 清除用户信息
  clearUserInfo({ commit }) {
    commit('CLEAR_USER_INFO')
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
